export type Theme = 'dark' | 'light'

const STORAGE_KEY = 'sezi.theme'

/** The theme currently applied to the document (set by the inline boot script
 *  in index.html, then kept in sync by ThemeToggle). Defaults to 'dark'. */
export function currentTheme(): Theme {
  if (typeof document === 'undefined') return 'dark'
  return document.documentElement.dataset.theme === 'light' ? 'light' : 'dark'
}

export function writeStoredTheme(theme: Theme): void {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(STORAGE_KEY, theme)
  } catch {
    // localStorage may be unavailable (private mode, sandboxed) — best-effort.
  }
}

export function applyTheme(theme: Theme): void {
  if (typeof document === 'undefined') return
  const el = document.documentElement
  el.dataset.theme = theme
  el.style.colorScheme = theme
}
